/** 签约 IP 屏蔽的省市编辑规则，与广告后台保持一省一行、直辖市整区的口径。 */
export const isDirectMunicipality = (province) =>
  ["北京", "天津", "上海", "重庆"].includes(String(province || "").replace(/市$/, ""));

/** 严格校验目录，防止查询失败或错误响应被当作空白配置保存。 */
export function readRegionDirectory(data) {
  if (!data || !Array.isArray(data.provinces) || !data.provinces.length) {
    throw new Error("省市目录格式错误，请重新加载");
  }
  const seen = new Set();
  return data.provinces.map((item) => {
    if (!item || typeof item.name !== "string" || !item.name.trim() || seen.has(item.name) ||
      !Array.isArray(item.cities) || item.cities.some((city) => typeof city !== "string" || !city.trim())) {
      throw new Error("省市目录格式错误，请重新加载");
    }
    seen.add(item.name);
    return { name: item.name, cities: isDirectMunicipality(item.name) ? [] : [...new Set(item.cities)] };
  });
}

/** 将 API 平铺记录归并为编辑行；整省规则覆盖同省冗余城市。 */
export function regionsToRows(regions, directory) {
  if (!Array.isArray(regions)) throw new Error("屏蔽配置格式错误，请重新加载");
  const rows = new Map();
  const wholeProvinces = new Set();
  regions.forEach((region) => {
    if (!region || typeof region.province !== "string" || typeof region.city !== "string") {
      throw new Error("屏蔽配置格式错误，请重新加载");
    }
    const province = directory.find((item) => item.name === region.province);
    if (!province || (!isDirectMunicipality(province.name) && region.city && !province.cities.includes(region.city))) {
      throw new Error("屏蔽配置包含未知省市，请检查省市目录");
    }
    if (!rows.has(province.name)) rows.set(province.name, { province: province.name, cities: [] });
    const row = rows.get(province.name);
    if (!region.city || isDirectMunicipality(province.name)) {
      wholeProvinces.add(province.name);
      row.cities = [];
    } else if (!wholeProvinces.has(province.name) && !row.cities.includes(region.city)) {
      row.cities.push(region.city);
    }
  });
  return [...rows.values()];
}

/** 保存前校验重复省份、城市归属；空 cities 对应整省的空 city。 */
export function rowsToRegions(rows, directory) {
  const seen = new Set();
  const regions = [];
  rows.forEach((row, index) => {
    const province = directory.find((item) => item.name === row.province);
    if (!province) throw new Error(`第 ${index + 1} 行请选择省份`);
    if (seen.has(province.name)) throw new Error(`“${province.name}”重复添加，请在同一行多选城市`);
    seen.add(province.name);
    if (!Array.isArray(row.cities)) throw new Error("城市配置格式错误");
    const cities = isDirectMunicipality(province.name) ? [] : [...new Set(row.cities)];
    if (cities.some((city) => !province.cities.includes(city))) throw new Error(`“${province.name}”包含不属于该省的城市`);
    (cities.length ? cities : [""]).forEach((city) => regions.push({ province: province.name, city }));
  });
  return regions;
}
